<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 650 : 'auto'"
    style="z-index: 1200 !important;"
  >
    <v-card v-cloak>
      <v-card-title class="d-flex justify-space-between">
        <span>{{ $t('console.ftpUsersHelp.title') }}</span>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text scrollable class="scrollable mt-4">
        <p>
          {{ $t('console.ftpUsersHelp.intro') }}
        </p>

        <div v-if="ftpServerAddress" class="my-4">
          <h3>{{ $t('console.ftpUsersHelp.ftpServerAddress') }}</h3>
          <div class="mt-2 pa-3 rounded border text-center font-weight-medium text-body-1">
            {{ ftpServerAddress }}
          </div>
        </div>

        <h3>{{ $t('console.ftpUsersHelp.creatingUsers') }}</h3>
        <p>
          {{ $t('console.ftpUsersHelp.creatingUsersText') }}
        </p>

        <h3>{{ $t('console.ftpUsersHelp.managingUsers') }}</h3>
        <p>
          {{ $t('console.ftpUsersHelp.managingUsersText') }}
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';
import DialogModel from '@/components/mixin/DialogModel.js';

export default {
  name: 'FTPUsersHelpDialog',
  mixins: [ DialogActionKeys, DialogModel ],
  computed: {
    ftpServerAddress() {
      return import.meta.env.VITE_FTP_URL;
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0.75rem;

  &:not(:first-child) {
    margin-top: 0.75rem;
  }
}

h3 {
  margin-top: 0.75rem;
}
</style>
